import React from 'react'

import CommunitySelectField from 'shared/components/community/components/select-field/CommunitySelectField'

import { FILTER_FEED_OPTIONS, SORTED_FEED_OPTIONS } from 'constants/communities.constants'
import UserActivityFilter from './UserActivityFilter'

const CommunityFilters = (props) => {
  const { filterLabels, handleGroupingChange, handleClear, communityId, selectedUser = {} } = props
  const memberId = selectedUser?.id
  const filterLabelsOptions = filterLabels.reduce(
    (prevName, label) => [
      ...prevName,
      {
        label: label.name,
        value: label.id,
      },
    ],
    FILTER_FEED_OPTIONS
  )

  return (
    <>
      <CommunitySelectField
        onChange={(value) => handleGroupingChange({ value, communityId, isSorting: true, memberId })}
        value={SORTED_FEED_OPTIONS[0]}
        options={SORTED_FEED_OPTIONS}
      />
      <CommunitySelectField
        onChange={(value) => handleGroupingChange({ value, communityId, memberId })}
        value={FILTER_FEED_OPTIONS[0]}
        options={filterLabelsOptions}
      />
      <UserActivityFilter
        user={selectedUser}
        handleClear={() => {
          handleGroupingChange({ communityId, memberId: null })
          handleClear()
        }}
      />
    </>
  )
}

export default CommunityFilters
